// Каса: форма входу («Вже купували? Увійти») — у попапі <dialog> замість розгортання над формою.
// WooCommerce вішає slideToggle на a.showlogin через делегування з body; наш обробник на самому
// посиланні зупиняє спливання, тож штатний toggle не спрацьовує.
const form = document.querySelector('.woocommerce-checkout form.woocommerce-form-login');
const links = document.querySelectorAll('.woocommerce-checkout a.showlogin');

if (form && links.length && typeof HTMLDialogElement === 'function') {
	const dialog = document.createElement('dialog');
	dialog.className = 'login-dialog';
	dialog.setAttribute('aria-labelledby', 'login-dialog-title');
	dialog.innerHTML = `
		<div class="login-dialog__head">
			<h2 class="login-dialog__title" id="login-dialog-title">Вхід</h2>
			<button type="button" class="login-dialog__close" aria-label="Закрити">
				<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M18 6 6 18M6 6l12 12"/></svg>
			</button>
		</div>`;

	form.style.display = '';
	dialog.appendChild(form);
	document.body.appendChild(dialog);

	const open = (e) => {
		e.preventDefault();
		e.stopPropagation();
		dialog.showModal();
		document.body.style.overflow = 'hidden';
		const field = form.querySelector('#username');
		if (field) field.focus();
	};

	links.forEach((link) => link.addEventListener('click', open));

	dialog.querySelector('.login-dialog__close').addEventListener('click', () => dialog.close());

	// Клік по затемненню (поза карткою) — закрити.
	dialog.addEventListener('click', (e) => {
		if (e.target === dialog) dialog.close();
	});

	dialog.addEventListener('close', () => {
		document.body.style.overflow = '';
	});
}
